import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCrown } from '@fortawesome/pro-light-svg-icons'

import { SidebarModal, SquareIconWithBackground } from '@domain-group/suit-theme'

import useAgencyMarketing from '@hooks/useAgencyMarketing'

interface AgencyMarketingButtonProps {
  shouldLaunchModal?: boolean,
}

const AgencyMarketingButton = (props: AgencyMarketingButtonProps) => {
  const { shouldLaunchModal = false } = props
  const {
    callbacks: { addAgencyMarketingCampaign },
  } = useAgencyMarketing()

  const navigationProps = shouldLaunchModal
    ? {
      onClick: () => addAgencyMarketingCampaign({
        hideComponents: ['ExistingCampaign'],
        createCampaignWithArtwork: false,
      }),
    }
    : {
      href: '#/agency/marketing',
    }

  return (
    <SidebarModal.Button
      iconLeft={
        <SquareIconWithBackground backgroundColor="#F8F7F4" color="tan" icon={<FontAwesomeIcon icon={faCrown} />} />
      }
      showAngleIcon
      subtitle="For selling yourself or your agency"
      title="Agency Marketing"
      {...navigationProps}
    />
  )
}
export default AgencyMarketingButton
